import { AdditionalFields } from '../domain/entities/inspirationalTemplate';
import { INSPIRATIONAL_TEMPLATE_MAP as EN_MAP } from './inspirationalTemplateMap.en';

export const INSPIRATIONAL_TEMPLATE_MAP: Record<string, AdditionalFields> = {
  'b991864c-cd05-498d-85e2-03459fdeb6ec': {
    backgroundColor: '#F3FFE0',
    shortDescription:
      '読者が思わずスクロールの手を止めてしまう、意外性あふれるシングルページデザインからインスピレーションを得ましょう。',
    features: [
      '透過動画',
      'ホバーアニメーション',
      'マーキーテキスト',
      'カスタムコード',
      'CSS グリッド',
      'ダウンロード用アセットライブラリー',
    ],
    inspirationalAssets:
      EN_MAP['b991864c-cd05-498d-85e2-03459fdeb6ec'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['b991864c-cd05-498d-85e2-03459fdeb6ec'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['b991864c-cd05-498d-85e2-03459fdeb6ec'].thumbnailUrl,
  },
  'd674b741-2412-4260-af3f-c5f0e964fcd5': {
    backgroundColor: '#F4EDFF',
    shortDescription:
      '無数の星がきらめく宇宙の旅のサイトで想像力を掻き立てましょう。',
    features: [
      'スクロールアニメーション',
      'ループアニメーション',
      '横方向スクロール',
      'ホバーエフェクト',
      'カスタム CSS',
    ],
    inspirationalAssets:
      EN_MAP['d674b741-2412-4260-af3f-c5f0e964fcd5'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['d674b741-2412-4260-af3f-c5f0e964fcd5'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['d674b741-2412-4260-af3f-c5f0e964fcd5'].thumbnailUrl,
  },
  '8de718ac-8cc4-4b69-88ab-4d92920c37a2': {
    backgroundColor: '#FFE8E4',
    shortDescription:
      'マーキーテキストの流れる文字でダイナミックな動きを追加して印象を残しましょう。',
    features: [
      'マーキーテキスト',
      'スクロールアニメーション',
      'ループアニメーション',
      'エントランスアニメーション',
      '背景スクロールエフェクト',
      'CSS グリッド',
    ],
    inspirationalAssets:
      EN_MAP['8de718ac-8cc4-4b69-88ab-4d92920c37a2'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['8de718ac-8cc4-4b69-88ab-4d92920c37a2'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['8de718ac-8cc4-4b69-88ab-4d92920c37a2'].thumbnailUrl,
  },
  '50d5ca42-112a-466a-aca2-fd8bc927a965': {
    backgroundColor: '#E2FFE2',
    shortDescription:
      'この非営利団体のメッセージに読者が思わず引き込まれてしまうような、魅力的なスクロールエフェクトやアニメーションからアイディアを得ましょう。',
    features: [
      'スクロールアニメーション',
      'ループアニメーション',
      'エントランスアニメーション',
      '透過動画',
      'CSS グリッド',
      'スタック',
    ],
    inspirationalAssets:
      EN_MAP['50d5ca42-112a-466a-aca2-fd8bc927a965'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['50d5ca42-112a-466a-aca2-fd8bc927a965'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['50d5ca42-112a-466a-aca2-fd8bc927a965'].thumbnailUrl,
  },
  '31ec1ed2-9432-46e2-8175-5e4ccab9b5b9': {
    backgroundColor: '#FFE6F1',
    shortDescription:
      'スクロールテリングでデータや統計に命を吹き込みましょう。',
    features: [
      'スクロールアニメーション',
      'ループアニメーション',
      'エントランスアニメーション',
      'マーキーテキスト',
      '背景グラデーション',
      '背景スクロールエフェクト',
    ],
    inspirationalAssets:
      EN_MAP['31ec1ed2-9432-46e2-8175-5e4ccab9b5b9'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['31ec1ed2-9432-46e2-8175-5e4ccab9b5b9'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['31ec1ed2-9432-46e2-8175-5e4ccab9b5b9'].thumbnailUrl,
  },
  '498fe8fb-46ba-45a5-9346-3bb5b1c9f61c': {
    backgroundColor: '#E6F2FF',
    shortDescription:
      '星座の神秘を解き明かす、この占星術サイトから次のプロジェクトのインスピレーションを得ましょう。',
    features: [
      'マウスエフェクト',
      'スティッキー配置',
      '横方向スクロール',
      'スクロールアニメーション',
      'カスタムコード',
    ],
    inspirationalAssets:
      EN_MAP['498fe8fb-46ba-45a5-9346-3bb5b1c9f61c'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['498fe8fb-46ba-45a5-9346-3bb5b1c9f61c'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['498fe8fb-46ba-45a5-9346-3bb5b1c9f61c'].thumbnailUrl,
  },
};
